import { OutlinedInputProps, TextField } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';

import { useVendor, useWindowSize } from 'hooks';
import { Invoice as InvoiceType } from 'models/invoicing';
import { getInvoiceStatus } from 'utils/invoice';

import DesktopInvoice from './DesktopInvoice';
import MobileInvoice from './MobileInvoice';

import './Invoice.scss';

type Props = {
  invoice?: InvoiceType;
  onInvoiceNumberChange?: OutlinedInputProps['onChange'];
} & RouteComponentProps;

const Invoice = ({ invoice, onInvoiceNumberChange }: Props) => {
  const { isVendor } = useVendor();
  const { isMobileViewport } = useWindowSize();
  let total = invoice?.totalAmountDue ?? 0;
  const invoiceStatus = invoice?.invoiceStatus;

  let statusComponent = null;
  // Only show invoiced status if user is vendor
  if (isVendor && invoice?.invoiceNumber && invoiceStatus === 'INVOICED') {
    statusComponent = (
      <div className="invoice-status invoiced">
        {getInvoiceStatus(invoiceStatus)}
      </div>
    );
  }
  if (invoiceStatus === 'PAID') {
    statusComponent = (
      <div className="invoice-status paid">
        {getInvoiceStatus(invoiceStatus)}
      </div>
    );
  }

  const isMobile = isMobileViewport();
  const invoiceNumber = invoice?.invoiceNumber ? (
    <div className="invoice-number-container">
      <div className="invoice-number-label">
        {isMobile ? 'Invoice #' : 'Invoice Number'}
      </div>
      <div className="invoice-number">{invoice?.invoiceNumber}</div>
    </div>
  ) : (
    <TextField
      className="invoice-number-input"
      onChange={onInvoiceNumberChange}
      required
      variant="outlined"
      size="small"
      placeholder="Invoice Number"
      autoFocus
      inputProps={{ maxLength: 30 }}
    />
  );

  if (!invoice) {
    return null;
  }

  return isMobile ? (
    <MobileInvoice
      invoice={invoice}
      invoiceNumber={invoiceNumber}
      statusComponent={statusComponent}
      total={total}
    />
  ) : (
    <DesktopInvoice
      invoice={invoice}
      invoiceNumber={invoiceNumber}
      statusComponent={statusComponent}
      total={total}
    />
  );
};

export default Invoice;
